import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";

import { CNPJ, CepV2, IbgeUF } from "./brasilApi.types";

export const brasilApi = createApi({
  reducerPath: "brasilApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://brasilapi.com.br/api" }),
  tagTypes: ["CNPJ", "CEP", "UF"],
  endpoints: (build) => ({
    getCepV2: build.query<CepV2, Pick<CepV2, "cep">>({
      query: ({ cep }) => `/cep/v2/${cep.replace(/\D/g, "")}`,
      providesTags: (response, err, { cep }) => [{ type: "CEP", id: cep }],
      onQueryStarted: async (arg, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Buscando CEP...",
          success: "CEP encontrado!",
          error: "Erro ao buscar CEP ou CEP inválido/inesistente!"
        });
      }
    }),
    getCnpj: build.query<CNPJ, Pick<CNPJ, "cnpj">>({
      query: ({ cnpj }) => `/cnpj/v1/${cnpj.replace(/\D/g, "")}`,
      providesTags: (response, err, { cnpj }) => [{ type: "CNPJ", id: cnpj }],
      onQueryStarted: async (arg, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Buscando CNPJ...",
          success: "CNPJ encontrado!",
          error: "Erro ao buscar CNPJ ou CNPJ inválido/inexistente!"
        });
      }
    }),
    getIbgeUF: build.query<Omit<IbgeUF, "regiao">[], void, IbgeUF[]>({
      query: () => `/ibge/uf/v1`,
      providesTags: (response) => (response ? [...response.map(({ id }) => ({ type: "UF" as const, id })), { type: "UF", id: "LIST" }] : [{ type: "UF", id: "LIST" }]),
      transformResponse: (response: IbgeUF[]) => {
        return response.map(({ nome, sigla, id }) => ({ id, nome, sigla }));
      }
    })
  })
});
